import { MISSING_RESPONSE } from '@/constants';

export const isDefined = <T>(
  value: T | undefined | null,
): value is NonNullable<T> => value !== undefined && value !== null;

export const isNotDefined = <T>(
  value: T | undefined | null,
): value is undefined | null => value === undefined || value === null;

export const isEmpty = (value: string | undefined | null): value is undefined =>
  value === undefined || value === null || value === '';

export const isNotEmpty = (value: string | undefined | null): value is string =>
  value !== undefined && value !== null && value !== '';

export const parseNumberWithCommas = (num: number) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const injectCustomHeadCode = (customHeadCode: string) => {
  const headCodes = customHeadCode.split('</noscript>');
  headCodes.forEach((headCode) => {
    const [codeToInject, noScriptContentToInject] =
      headCode.split('<noscript>');
    const fragment = document
      .createRange()
      .createContextualFragment(codeToInject);
    document.head.append(fragment);

    if (isNotDefined(noScriptContentToInject)) return;

    const noScriptElement = document.createElement('noscript');
    const noScriptContentFragment = document
      .createRange()
      .createContextualFragment(noScriptContentToInject);
    noScriptElement.append(noScriptContentFragment);
    document.head.append(noScriptElement);
  });
};

export const createUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
};

export const supportedLanguages = [
  'en',
  'ar',
  'de',
  'es',
  'fr',
  'da',
  'nl',
  'pt',
  'ru',
  'zh',
  'ja',
  'ko',
  'fa',
  'th',
];

// get language code from language
// eg: en-US => en
export const getLanguageCode = (language: string) => {
  const code = language.split('-')[0];
  if (supportedLanguages.includes(code)) {
    return code;
  }

  return 'en';
};

// get language from browser
export const getLanguageFromBrowser = () => {
  return getLanguageCode(navigator.language);
};

export type CommandData = {
  isFromBrainfish: boolean;
  command: 'openHelpDrawer' | 'toggleHelpDrawer' | 'closeHelpDrawer';
  trigger?: string;
};

export const isMissingResponse = (answer: string) => {
  const regex = new RegExp(MISSING_RESPONSE, 'i');

  return regex.test(answer);
};
